import { render, staticRenderFns } from "./Before.vue?vue&type=template&id=7d849276&scoped=true&"
import script from "./Before.vue?vue&type=script&lang=js&"
export * from "./Before.vue?vue&type=script&lang=js&"
import style0 from "./Before.vue?vue&type=style&index=0&id=7d849276&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d849276",
  null
  
)

export default component.exports